import CircularProgress from '@material-ui/core/CircularProgress'

export default function CircularIndeterminate(props) {
    return (
        <div>
            <CircularProgress color="secondary" {...props} />
        </div>
    )
}
